import { render, staticRenderFns } from "./ProductChangesTable.vue?vue&type=template&id=7211a8c4&scoped=true&"
import script from "./ProductChangesTable.vue?vue&type=script&lang=js&"
export * from "./ProductChangesTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductChangesTable.vue?vue&type=style&index=0&id=7211a8c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7211a8c4",
  null
  
)

export default component.exports